export enum FleetSettingsKeys {
    DefaultRecallMax = 'default_recall_max',
    LiveVideoMonthlyLimitSeconds = 'live_video_monthly_limit_seconds',
}
